import { IOfferCard } from '../../../../types';

export const prepareProfileLink = ({ offerUser }: IOfferCard) => {
  const { profileUri } = offerUser?.masterAgent || offerUser || {};

  if (!profileUri) {
    return;
  }

  return `https://cian.ru/${profileUri}`;
};
